export default {"src":"/_next/static/media/laptop_64.20f493a7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};